import { VSpacer } from '@/components/DesignSystem';
import ERPRetailerSelector from "@/components/shared/ListSelector/ERPRetailerSelector";
import OrderTransactionList from '@/pages/Admin/Orders/OrderTransactionList';
import { ApiRetailer } from '@api/interfaces';
import { Alert, Container, Divider, Stack } from '@mui/material';
import React, { useState } from 'react';

const OrdersOverview = () => {
  const [errorMessage, setErrorMessage] = useState('');
  const [selectedRetailer, setSelectedRetailer] = useState<ApiRetailer | undefined>();

  const onRetailerSelected = (retailer?: ApiRetailer) => {
    if (retailer?.id !== selectedRetailer?.id) {
      setSelectedRetailer(retailer);
    }
  };

  return (
    <Container maxWidth="lg">
      <Stack>
        <ERPRetailerSelector
          header='Orders'
          logo="growers"
          onSelect={onRetailerSelected}
        />
        <VSpacer size="6" />
        <Divider />
        <VSpacer size="6" />
        {!!errorMessage && (
          <Alert color="error" icon={false}>{errorMessage}</Alert>
        )}
        {selectedRetailer && (
          <OrderTransactionList onError={setErrorMessage} selectedRetailer={selectedRetailer} />
        )}
      </Stack>
    </Container>
  );
};


export default OrdersOverview;
